import { memo } from "react";
import { useTranslate } from "helpers";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonGroup from "ui/components/Button/ButtonMenu/ButtonGroup";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { VehicleDetailRef } from "../../../VehicleDetailCard/types";

interface VehicleDocumentationMenuProps {
  vehicleId: string;
  /** Prodano vozilo je arhivirano — ponude i ugovori se ne kreiraju, računi i dalje da. */
  isSold?: boolean;
  vehicleDetailRef?: React.RefObject<VehicleDetailRef | null>;
}

const SOLD_TOOLTIP = "Vozilo je prodano";

const VehicleDocumentationMenu: React.FC<VehicleDocumentationMenuProps> = ({ vehicleId, isSold, vehicleDetailRef }) => {
  const { t } = useTranslate();

  const handleOfferClick = () => {
    vehicleDetailRef?.current?.openAddNewOfferSale();
  };

  const handleContractClick = () => {
    vehicleDetailRef?.current?.openAddNewContractSale();
  };

  const handleInvoiceClick = () => {
    vehicleDetailRef?.current?.openAddNewInvoiceSale();
  };

  const handleOfferRentClick = () => {
    vehicleDetailRef?.current?.openAddNewOfferRent();
  };

  const handleContractRentClick = () => {
    vehicleDetailRef?.current?.openAddNewContractRent();
  };

  const handleInvoiceRentClick = () => {
    vehicleDetailRef?.current?.openAddNewInvoiceRent();
  };

  return (
    <>
      <ButtonMenu
        text={t("admin.fleet.vehicle.detail.documentation.menu")}
        size="large"
        variant="secondary"
        endIcon="/media/icons/chevron-down.svg"
        groupDirection="horizontal"
      >
        <ButtonGroup text={t("admin.fleet.vehicle.detail.documentation.menu.group.sale")}></ButtonGroup>

        <ButtonMenuItem
          startIcon="/media/icons/offer.svg"
          onClick={handleOfferClick}
          disabled={isSold}
          tooltip={isSold ? SOLD_TOOLTIP : undefined}
        >
          {t("admin.fleet.vehicle.detail.documentation.menu.sale.offer")}
        </ButtonMenuItem>
        <ButtonMenuItem
          startIcon="/media/icons/contract.svg"
          onClick={handleContractClick}
          disabled={isSold}
          tooltip={isSold ? SOLD_TOOLTIP : undefined}
        >
          {t("admin.fleet.vehicle.detail.documentation.menu.sale.contract")}
        </ButtonMenuItem>
        <ButtonMenuItem
          startIcon="/media/icons/invoice.svg"
          onClick={handleInvoiceClick}
        >
          {t("admin.fleet.vehicle.detail.documentation.menu.invoice")}
        </ButtonMenuItem>

        <ButtonGroup text="NAJAM VOZILA"></ButtonGroup>

        <ButtonMenuItem
          startIcon="/media/icons/offer.svg"
          onClick={handleOfferRentClick}
          disabled={isSold}
          tooltip={isSold ? SOLD_TOOLTIP : undefined}
        >
          Ponuda
        </ButtonMenuItem>
        <ButtonMenuItem
          startIcon="/media/icons/contract.svg"
          onClick={handleContractRentClick}
          disabled={isSold}
          tooltip={isSold ? SOLD_TOOLTIP : undefined}
        >
          Ugovor
        </ButtonMenuItem>
        <ButtonMenuItem
          startIcon="/media/icons/invoice.svg"
          onClick={handleInvoiceRentClick}
        >
          Račun
        </ButtonMenuItem>
      </ButtonMenu>
    </>
  );
};

export default memo(VehicleDocumentationMenu);
